$('.bs-pro-button--subscribe-close-btn').on('click', function () {
	$('.bs-section--stay-up-date').slideUp();
});
